var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "node-branch-box" },
    [
      _c("custom-tree-node", {
        staticClass: "node-father",
        class: { "node-father-has": _vm.hasChild },
        attrs: {
          index: 0,
          firstIndex: _vm.firstIndex,
          data: _vm.data,
          hasChild: _vm.hasChild,
        },
        on: { delete: _vm.onDelete },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }